import { PopoverAlertComponent } from './../popover-alert/popover-alert.component';
import { PopoverConfirmationComponent } from './../popover-confirmation/popover-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LocalStorageService } from './../../services/local-storage.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isSidebarOpen = false;
  navLinks: any[];
  public userFirstname: string;
  public admin_path: any[] = ['Accueil', 'Administrateurs'];
  public admin_path_add: any[] = [
    ...this.admin_path,
    "Ajout d'un nouvel admin",
  ];
  public admin_path_edit: any[] = [
    ...this.admin_path,
    'Modifier un administrateur',
  ];
  public ufa_path: any[] = ['Accueil', 'Nos UFA & formations'];
  public ufa_path_add: any[] = [...this.ufa_path, "Ajout d'un nouvel UFA"];
  public ufa_path_edit: any[] = [...this.ufa_path, 'Modifier un UFA'];
  public training_ufa_path_: any[] = [...this.ufa_path, 'Liste des formation'];
  public business_card_path: any[] = ['Accueil', 'Nos fiches métiers'];
  public business_card_path_add: any[] = [
    ...this.business_card_path,
    "Ajout d'une nouvelle fiche métier",
  ];
  public business_card_path_edit: any[] = [
    ...this.business_card_path,
    'Modifier fiche métier',
  ];
  public faq_path: any[] = ['Accueil', 'FAQ'];
  public faq_path_add: any[] = [
    ...this.faq_path,
    "Ajout d'une nouvelle question/réponse",
  ];
  public faq_path_edit: any[] = [
    ...this.faq_path,
    'Modifier une question/réponse',
  ];
  public news_path: any[] = ['Accueil', 'Actualités'];
  public news_path_add: any[] = [
    ...this.news_path,
    "Ajout d'une nouvelle actualité",
  ];
  public news_path_edit: any[] = [...this.news_path, 'Modifier une actualité'];

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.navLinks = [
      {
        label: 'A propos',
        link: '',
        index: 0,
      },
      {
        label: 'Professionnels de santé',
        link: '',
        index: 1,
      },
      {
        label: 'Patients',
        link: '',
        index: 2,
      },
      {
        label: 'Blog',
        link: '',
        index: 3,
      },
    ];
  }

  ngOnInit() {
    this.userFirstname = this.localStorageService.getCurrentUser().firstname;
  }

  logout() {
    const dialogRef = this.dialog.open(PopoverConfirmationComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: '70%',
      panelClass: 'custom-modalbox',
      data: {
        id: 0,
        status: 'info',
        message: 'Etes-vous sur de vouloir vous déconnecter ?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dialog.closeAll();
        this.dialog.open(PopoverAlertComponent, {
          disableClose: true,
          hasBackdrop: true,
          height: '40%',
          panelClass: 'custom-modalbox',
          data: {
            text: 'Déconnexion en cours ... ',
            isLoader: true,
          },
        });
        this.dialog.closeAll();
        this.localStorageService.logout();
        this.router.navigate(['login']);
      }
    });
  }

  setBreadcrumb() {
    // if (this.route.url.includes('ad'))
  }

  sidebarToggle() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
}
